(function () {
  function init(root) {
    if (!root || root.dataset.oGrReady) return;
    root.dataset.oGrReady = '1';
    var rail = root.querySelector('[data-o-gr-rail]');
    var chips = root.querySelectorAll('[data-o-gr-filter]');
    var cards = root.querySelectorAll('[data-o-gr-card]');
    var prev = root.querySelector('[data-o-gr-prev]');
    var next = root.querySelector('[data-o-gr-next]');

    function setFilter(code) {
      chips.forEach(function (c) {
        c.classList.toggle('is-active', c.getAttribute('data-o-gr-filter') === code);
      });
      cards.forEach(function (card) {
        var store = card.getAttribute('data-store-code') || '';
        var show = code === 'all' || store === code;
        if (show) card.removeAttribute('hidden');
        else card.setAttribute('hidden', '');
      });
      if (rail) rail.scrollTo({ left: 0, behavior: 'smooth' });
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        setFilter(chip.getAttribute('data-o-gr-filter') || 'all');
      });
    });

    root.querySelectorAll('[data-o-gr-more]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var card = btn.closest('[data-o-gr-card]');
        if (!card) return;
        var text = card.querySelector('[data-o-gr-text]');
        if (!text) return;
        var open = text.classList.toggle('is-open');
        btn.textContent = open ? (btn.getAttribute('data-less') || 'Read less') : (btn.getAttribute('data-more') || 'Read more');
      });
    });

    function scrollByDir(dir) {
      if (!rail) return;
      var amount = Math.max(rail.clientWidth * 0.85, 300);
      rail.scrollBy({ left: dir * amount, behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { scrollByDir(-1); });
    if (next) next.addEventListener('click', function () { scrollByDir(1); });
  }

  function boot() {
    document.querySelectorAll('[data-o-gr]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) e.target.querySelectorAll('[data-o-gr]').forEach(init);
  });
})();
